/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  FeedbackDto,
  FeedbackSearchRequest,
  SubmitFeedbackParams,
  SubmitFeedbackPayload,
  SubmitFeedbackV2Payload,
  UpdateFeedbackRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiFeedbackController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-feedback-controller
   * @name SubmitFeedback
   * @request POST:/api/v1/feedback
   */
  submitFeedback = (
    query: SubmitFeedbackParams,
    data: SubmitFeedbackPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<FeedbackDto, any>({
      path: `/v1/feedback`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static submitFeedbackPath = '/v1/feedback'
  static submitFeedbackMethod = 'POST'
  /**
   * No description
   *
   * @tags api-feedback-controller
   * @name SubmitFeedbackV2
   * @request POST:/api/v1/feedback/v2
   */
  submitFeedbackV2 = (data: SubmitFeedbackV2Payload, params: RequestParams = {}) =>
    this.http.request<FeedbackDto, any>({
      path: `/v1/feedback/v2`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static submitFeedbackV2Path = '/v1/feedback/v2'
  static submitFeedbackV2Method = 'POST'
  /**
   * No description
   *
   * @tags api-feedback-controller
   * @name ListFeedback
   * @request POST:/api/v1/feedback/list
   */
  listFeedback = (data: FeedbackSearchRequest, params: RequestParams = {}) =>
    this.http.request<FeedbackDto[], any>({
      path: `/v1/feedback/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static listFeedbackPath = '/v1/feedback/list'
  static listFeedbackMethod = 'POST'
  /**
   * No description
   *
   * @tags api-feedback-controller
   * @name GetFeedback
   * @request GET:/api/v1/feedback/{id}
   */
  getFeedback = (id: string, params: RequestParams = {}) =>
    this.http.request<FeedbackDto, any>({
      path: `/v1/feedback/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getFeedbackPath = '/v1/feedback/${id}'
  static getFeedbackMethod = 'GET'
  /**
   * No description
   *
   * @tags api-feedback-controller
   * @name DeleteFeedback
   * @request DELETE:/api/v1/feedback/{id}
   */
  deleteFeedback = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/feedback/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteFeedbackPath = '/v1/feedback/${id}'
  static deleteFeedbackMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-feedback-controller
   * @name UpdateFeedback
   * @request PATCH:/api/v1/feedback/{id}
   */
  updateFeedback = (id: string, data: UpdateFeedbackRequest, params: RequestParams = {}) =>
    this.http.request<FeedbackDto, any>({
      path: `/v1/feedback/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateFeedbackPath = '/v1/feedback/${id}'
  static updateFeedbackMethod = 'PATCH'
}
